export function productShowReservedValidate(product){
    var result = true;

    result = validateCode(product.code)

    return result;
}

function validateCode(code){    
    if(Number.isInteger(code)) return true;
    else return false;
}